import styled from "styled-components";

import { SessionTypeStyledProps as Props } from "./SessionType.types";
import CONSTANTS from "config/constants";

const { tablet } = CONSTANTS.BREAKPOINTS;

const SessionTypeStyled = styled.div<Props>`
  display: flex;
  flex-direction: column;

  @media (max-width: ${tablet}px) {
    padding: 0.8rem;
  }

  .SessionType {
    &__theater-type {
      display: flex;
      flex-direction: column;
    }

    &__name {
      color: var(--palette-white);
      font-size: 2.8rem;
      font-weight: 600;

      @media (max-width: ${tablet}px) {
        font-size: 1.6rem;
      }
    }

    &__separator {
      margin-top: 4rem;
      margin-bottom: 2.4rem;
      background-color: var(--palette-mid-blue-s15-l8);
      height: 0.8rem;
      border-radius: 0.8rem;

      @media (max-width: ${tablet}px) {
        margin: 2.4rem 0;
        margin-bottom: 0;
      }
    }

    &__divider {
      height: 0.2rem;
      margin: 1.6rem 0;
      border-bottom: dashed
        ${props =>
          props.isPremiere
            ? "var(--palette-gray-s0-l40-a40)"
            : "var(--palette-light-blue-s10-l60)"};

      @media (max-width: ${tablet}px) {
        margin: 1rem 0;
        margin-bottom: 0;
      }
    }
  }
`;

export default SessionTypeStyled;
